
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TheHeader',
  setup() {
    const { header, subHeader, interval } = window.__PRE_CONFIG__;
    const host = window.location.host;
    return {
      header,
      subHeader,
      interval,
      host
    };
  }
});
